import { Reducer } from 'redux';
import { APPLICATIONS_FETCH_SUCCESS, IApplicationsFetchAction } from '../actions/applications';
import { IApplicationsState } from '../types/application';

export const initialState: IApplicationsState = {
  applications: [],
  meta: {
    has_next: false,
    has_previous: false,
  },
};

const reducer: Reducer<IApplicationsState> = (
  state: IApplicationsState = initialState,
  action: IApplicationsFetchAction
) => {
  switch (action.type) {
    case APPLICATIONS_FETCH_SUCCESS:
      return { applications: action.payload.applications, meta: action.payload.meta };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/applications.ts